import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { AppContext, SeoService } from '../../shared';
import { BlogPage } from  '../blog-page';

@Component({
  selector: 'linescape-celebrates-10th-anniversary',
  template: require('./linescape-celebrates-10th-anniversary.component.html'),
  styles: [require('./../blog.component.scss'), require('./linescape-celebrates-10th-anniversary.component.scss')]
})
export class LinescapeCelebrates10thAnniversaryComponent extends BlogPage {
  title = "Linescape celebrates 10th Anniversary by adding Port Terminal Names to Port Calls - Linescape";
  description = "Leading Sailing Schedule data provider enhances port calls with berth or terminal names.";

  constructor(route: ActivatedRoute, app: AppContext, seo: SeoService) {
    super(route, app, seo);
  }
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/press/linescape-celebrates-10th-anniversary/linescape-celebrates-10th-anniversary.component.ts